import axios from "axios";
import { BASE_URL } from "./api";

// Icon mapping for dynamic icon resolution
export const ICON_MAP = {
  BsPeople: "BsPeople",
  BsFileEarmarkText: "BsFileEarmarkText",
  BsPersonBadge: "BsPersonBadge",
  BsUiChecksGrid: "BsUiChecksGrid",
  BsGear: "BsGear",
  BsClipboardCheck: "BsClipboardCheck",
  BsPlug: "BsPlug",
  BsGraphUp: "BsGraphUp",
  BsSignpost2: "BsSignpost2",
  BsCalendarEvent: "BsCalendarEvent",
  BsShieldCheck: "BsShieldCheck",
  BsCalendarCheck: "BsCalendarCheck",
  BsClockHistory: "BsClockHistory",
  BsCashStack: "BsCashStack",
  BsCreditCard: "BsCreditCard",
  BsCreditCard2Back: "BsCreditCard2Back",
  BsBoxArrowRight: "BsBoxArrowRight",
  BsBank: "BsBank",
  BsReceipt: "BsReceipt",
  BsChatDots: "BsChatDots",
  BsMortarboard: "BsMortarboard",
  BsPhone: "BsPhone",
  BsBarChart: "BsBarChart",
  BsRocketTakeoff: "BsRocketTakeoff",
  BsStickies: "BsStickies",
};

/**
 * Get sidebar modules from backend
 */
export const getSidebarModules = async () => {
  try {
    // Get auth token - check both locations
    const company = JSON.parse(localStorage.getItem("company") || "{}");
    const directToken = localStorage.getItem("token");
    const token = company.token || directToken;
    const companySlug = company.slug;

    if (!token) {
      console.warn("[Sidebar Service] No authentication token found");
      throw new Error("Not authenticated");
    }

    console.log(
      "[Sidebar Service] Fetching modules from:",
      `${BASE_URL}/api/sidebar/modules`,
    );
    console.log(
      "[Sidebar Service] Using token:",
      token ? `${token.substring(0, 20)}...` : "none",
    );

    const response = await axios.get(`${BASE_URL}/api/sidebar/modules`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-Company-Slug": companySlug || "",
      },
    });

    console.log(
      "[Sidebar Service] Modules fetched successfully:",
      response.data.data?.length || 0,
    );
    return response.data.data;
  } catch (error) {
    console.error(
      "[Sidebar Service] Error fetching sidebar modules:",
      error.message,
    );
    throw error;
  }
};

/**
 * Update sidebar modules (Admin only)
 */
export const updateSidebarModules = async (modules, companyId = null) => {
  try {
    const company = JSON.parse(localStorage.getItem("company") || "{}");
    const token = company.token;
    const companySlug = company.slug;

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await axios.post(
      `${BASE_URL}/api/sidebar/modules`,
      {
        modules,
        companyId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Company-Slug": companySlug,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error updating sidebar modules:", error);
    throw error;
  }
};

/**
 * Delete a sidebar module (Admin only)
 */
export const deleteSidebarModule = async (moduleId) => {
  try {
    const company = JSON.parse(localStorage.getItem("company") || "{}");
    const token = company.token;
    const companySlug = company.slug;

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await axios.delete(
      `${BASE_URL}/api/sidebar/modules/${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Company-Slug": companySlug,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting sidebar module:", error);
    throw error;
  }
};
